<template>
    <m-layout>
      <div fill-height class="daily fill-height" style="width:100%; position:relative">
        <!-- <v-card-title class="m-page__title">
          <span class="headline">Daily report</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title> -->

        <m-daily-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-daily-form>
        <m-daily-edit-form :form="form" :report="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-daily-edit-form>
<v-tabs>
        <v-tab>
        <v-icon left>chat</v-icon>
        Reports
      </v-tab>
        <v-tab>
        <v-icon left>post_add</v-icon>
        Tasks
      </v-tab>
      <v-tab-item>
        <div style="max-width:100%; position:relative" class="mt-3">
          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              class="reports"

              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, {text:'All', value:-1}]
              }"
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">

              <td >{{ item.date }}</td>
              <td >{{ item.time }}</td>
              <td >
                <div class="report" style=" ">
                  <div style="position: absolute; right: 10px;">
                    user: {{ item.user }}
                  </div>
                  <pre>{{ item.report }}</pre>
                </div>
              </td>
              <td>
                <div style="display: flex">
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                </div>
              </td>
              </tr>
              </tbody>
            </template>

            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </div>
</v-tab-item>
<v-tab-item>
        <m-tasks></m-tasks>
</v-tab-item>
</v-tabs >
      </div>
    </m-layout>
</template>

<script>
  import DailyMixin from '@/mixins/daily'

  export default {
    mixins: [DailyMixin],
    data () {
      return {
        snack: false
      }
    },
    methods: {
      save () {
        this.snack = true
      },
      cancel () {
        this.snack = true
      },
      open () {
        this.snack = true
      },
      close () {
        console.log('Dialog closed')
      },
    },
  }
</script>

<style lang="scss">

.daily {
  .theme--light.v-data-table.reports,
  .theme--light.v-tabs-items,
  .theme--light.v-tabs>.v-tabs-bar{
    background-color: transparent;
  }
  .report {
    width: 100%;
    position: relative;
    padding: 10px 0;
    pre {
      font-family: Roboto,sans-serif;
      white-space: pre-wrap;       /* css-3 */
    }
  }

}
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









